import { render, staticRenderFns } from "./ChatOrderHistoryPanel.vue?vue&type=template&id=786dc658&scoped=true&"
import script from "./ChatOrderHistoryPanel.vue?vue&type=script&lang=js&"
export * from "./ChatOrderHistoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderHistoryPanel.vue?vue&type=style&index=0&id=786dc658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786dc658",
  null
  
)

export default component.exports